const decodeToken = (token: string): Record<string, number> => {
  const buffer = atob(token.match(/[^.]+/g)?.[1] ?? '');
  return JSON.parse(buffer.toString());
};
export default decodeToken;
